// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1WRMn","label":"Category_label__1FO78","content":"Category_content__1vbT2","header":"Category_header__3Xv2l","location":"Category_location__2fnqo"};